import './BookReadOnlineButton.css'
import * as React from "react";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import LoadingButton from '@mui/lab/LoadingButton';
import BookDownloadButton from "./BookDownloadButton";
import {formatBookName} from "../../../../Functions/Formatter";
import FullScreenPopup from "../../../../Components/FullScreenPopup/FullScreenPopup";
import DownloadLimitExceededPopup from "../../../../Components/DownloadLimit/DownloadLimitExceededPopup";

class BookReadOnlineButton extends React.Component {

  state = {
    open: false,
    link: null,
    limitExceeded: false,
    loading: false
  };

  openReader() {
    if (this.state.link) {
      this.setState({open: true});
    } else {
      this.setState({loading: true});

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaKey, {action: 'submit'}).then(
          function (token) {
            fetch('/api/books/' + this.props.bookId + '/preview', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Captcha-Token': token
              },
              body: JSON.stringify(this.details)
            })
              .then(response => {
                if (response.ok) {
                  return response.text();
                } else {
                  throw new Error(response.status.toString())
                }
              })
              .then(url => {
                this.setState({open: true, link: url, loading: false, limitExceeded: false})
              })
              .catch(reason => {
                if (reason.message === "401") {
                  this.setState({limitExceeded: true, loading: false});
                }
              });
          }.bind(this));
      }.bind(this));
    }
  }

  closeReader() {
    this.setState({open: false})
  }

  handleClose() {
    this.setState({limitExceeded: false});
  }

  render() {
    return (
      <React.Fragment>
        <LoadingButton loading={this.state.loading} variant="outlined" startIcon={<ChromeReaderModeIcon/>} onClick={this.openReader.bind(this)}>
          Read Online
        </LoadingButton>
        <DownloadLimitExceededPopup open={this.state.limitExceeded} action="read online or download" mediaType="books" onClose={this.handleClose.bind(this)} />
        {
          this.state.open &&
          <FullScreenPopup open={this.state.open} onClose={this.closeReader.bind(this)} title={formatBookName(this.props.bookName)}>
            <div className={"book-read-iframe-wrapper"}>
              <div className={"book-read-iframe-overlay"}>
                <BookDownloadButton variant="icon" bookId={this.props.bookId} fileName={this.props.fileName} />
              </div>
              <iframe title="Book Reader" className={"book-read-iframe"} src={this.state.link} frameBorder={0} allow="autoplay"/>
            </div>
          </FullScreenPopup>
        }
      </React.Fragment>
    );
  }

}

export default BookReadOnlineButton;
